import React from 'react';
import { motion } from 'framer-motion';

export interface PageHeroProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  eyebrow?: React.ReactNode;
  align?: 'center' | 'left';
  showDivider?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const PageHero: React.FC<PageHeroProps> = ({
  title,
  subtitle,
  eyebrow,
  align = 'center',
  showDivider = true,
  className = '',
  children,
}) => {
  const alignClass = align === 'center' ? 'text-center' : 'text-left';

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.75, ease: 'easeOut' }}
      className={`page-max ${alignClass} ${className}`}
    >
      {eyebrow && (
        <p className="text-sm font-medium uppercase tracking-widest text-primary-400/90 mb-3">{eyebrow}</p>
      )}
      <h1 className="text-5xl md:text-7xl font-display font-bold gradient-text mb-6">{title}</h1>
      {showDivider && (
        <div
          className={`h-1 w-24 rounded-full bg-gradient-to-r from-primary-500/30 via-secondary-500/30 to-primary-500/30 mb-6 ${
            align === 'center' ? 'mx-auto' : ''
          }`}
        />
      )}
      {subtitle && (
        <p
          className={`text-lg md:text-xl text-dark-300 max-w-3xl leading-relaxed ${
            align === 'center' ? 'mx-auto' : ''
          }`}
        >
          {subtitle}
        </p>
      )}
      {children}
    </motion.div>
  );
};

export default PageHero;
